import { AfterViewInit, Component, OnDestroy } from "@angular/core";
import { EMPTY, Observable, Subscription, catchError, forkJoin, map, tap, switchMap } from "rxjs";
import { OperationError } from "@indusoft/angular-base-services";

import { ConfigurationHttpService } from "../../../common/services/configuration.service";

/**
 * Обёртка над indusoft/authenticator для AAS аутентификации.
 * Инкапсулирует получение AAS токена и добавление к http запросам.
 */
@Component({
    selector: 'aas-authenticator',
    templateUrl: 'aas-authenticator.component.html'
})
export class AasAuthenticatiorComponent implements AfterViewInit, OnDestroy {
    private sub?: Subscription;
    public aasHost: string = '';
    public aasEnabled: boolean = true;

    constructor(
        private configurationHttpService: ConfigurationHttpService
    ) {
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.init().subscribe();
    }

    private init(): Observable<void> {
        return this.configurationHttpService.getAuthConfiguration()
            .pipe(
                switchMap((config) => {
                    if (config instanceof OperationError) {
                        console.error('Failed to load auth configuration:', config);
                        this.aasEnabled = false;
                        return EMPTY;
                    }

                    const authProviderName = config?.providerName || null;
                    this.aasEnabled = authProviderName === "AAS";

                    if (!this.aasEnabled) {
                        return EMPTY;
                    }

                    return this.configurationHttpService.getAasConfiguration()
                        .pipe(
                            tap(config => {
                                this.aasHost = config.address;
                            }),
                            map(() => void 0)
                        );
                }),
                catchError(err => this.handleInitError(err))
            );
    }

    private handleInitError(err: any): Observable<void> {
        console.error("AAS init error", { error: err });
        return EMPTY;
    }
}
